// extracted by mini-css-extract-plugin
export var footerLinks = "footer-module--footerLinks--6d441";
export var linkGap = "footer-module--linkGap--1db97";
export var logo = "footer-module--logo--62dd1";
export var navGroup = "footer-module--navGroup--33c10";
export var paddingTop = "footer-module--paddingTop--e0680";
export var paddingTopSmallScreen = "footer-module--paddingTopSmallScreen--23e76";
export var textDecorationNone = "footer-module--textDecorationNone--8c8de";